import React, { Children, useEffect, useState } from "react"

import "./StageContainer.scss"

const StageChild = ({ elem, isActive }) => {
  //we give the stage component some time to animate out, so setting the subcomponent to not be visible is set on a timer separate from the css actually hiding it with the opacity property.
  const [visible, setVisible] = useState(true)

  useEffect(() => {
  
    let timer1 = setTimeout(() => setVisible(isActive), 500)

    // this will clear Timeout when component unmount like in willComponentUnmount
    return () => {
      clearTimeout(timer1)
    }
  }, [isActive])
  return <div className={`step-stage  ${visible ? `is--visible` : ""} ${isActive ? `is--active` : ""}`}>{elem}</div>
}

const StageContainer = ({ children, itemActive, ...props }) => {
  return (
    <div className={`step-stage-container`}>
      {Children.map(children, (child, i) => {
        const thisOneActive = itemActive === i
        const theElem = React.cloneElement(child, { isActive: thisOneActive });
        return <StageChild key={`stage-child-${i}`} elem={theElem} isActive={thisOneActive} />
      })}
    </div>
  )
}

export default StageContainer
